import React from 'react';
import { motion } from 'framer-motion';

const Download = () => {
    return (
        <section className="section download-section" id="download">
            <div className="container">
                <motion.div
                    className="download-content"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <h2 className="section-title text-white">
                        Başarıya Giden Yolda<br />İlk Adımı Atın
                    </h2>
                    <p className="section-subtitle text-white-opacity">
                        Soruly ile çalışmalarınızı düzenleyin, analizlerinizi takip edin ve hedeflerinize ulaşın. Hemen ücretsiz indirin.
                    </p>
                    <div className="hero-buttons download-buttons">
                        <motion.a
                            href="https://play.google.com/store/apps/details?id=com.soruly.app"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-primary btn-white"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Google Play'den İndir
                        </motion.a>

                        <motion.a
                            href="https://play.google.com/store/apps/details?id=com.soruly.app"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-secondary btn-white"
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            App Store'dan İndir
                        </motion.a>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Download;
